import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { EventUtil } from "../../util/EventUtil";
import { LandingCardLoader } from "../genericLanding/LandingCardLoader";
import { PageContext } from "../../service/PageContext";
import { WyanokeUtil } from "../../util/WyanokeUtil";
import { UrlUtil } from "../../util/UrlUtil";

interface ISpecialtyListItem {
  element: HTMLAnchorElement;
  text: string;
  url: string | null;
  value: string | null;
}

export class SpecialtySelect extends Component {

  public static readonly SpecialtySelectInitEvent: string =
    "SpecialtySelect::InitEvent";

  public static readonly LoadPageEvent = "LandingCardLoaderLoadPageEvent";

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);
  }

  public async init(): Promise<void> {
    const matchedUrlPattern = this.attemptUrlPatternMatch();

    if (!matchedUrlPattern) {

      // tslint:disable-next-line: comment-type
      /* showall query string doesn't exist
         referrer is not current host
         path is either / or /news  */
      if (new URLSearchParams(window.location.search).get("showall") !== "1" &&
        document.referrer.indexOf(window.location.hostname) === -1 &&
        ["/"].indexOf(window.location.pathname) !== -1) {
        await this.attemptUserProfileMatch();
      }
    }

    this._element
      .querySelectorAll("[data-action='select specialty']")
      .forEach(
        el => el.addEventListener(
          "click",
          ev => this.handleSpecialtyClick(ev)));

    const mobileH1 =
      document.querySelector("h1[data-specialty-title='mobile']");

    if (mobileH1) {
      mobileH1.textContent = this.selectedElement ?
        this.selectedElement.textContent : this.getCurrentDropDownValue() ?
          this.getCurrentDropDownValue() : "";
    }

    // this lies outside the component
    const specialtyHealder = document.querySelector(".specialty-toggler-text")
    if(specialtyHealder && this.selectedElement){
      specialtyHealder.textContent = this.selectedElement.textContent ? this.getCurrentDropDownValue() + " CME" : "";
    }

    this._element.dispatchEvent(
      EventUtil.createCustomEvent(SpecialtySelect.SpecialtySelectInitEvent,
        this.specialty));
  }

  public get specialty(): string {
    const active = this.selectedElement;

    return active ? active.dataset.value || "" : "";
  }

  public get specialtyName(): string {
    const active = this.selectedElement;

    return active ? active.textContent || "" : "";
  }

  private get specialties(): ReadonlyArray<ISpecialtyListItem> {
    return this.specialtyElements
      .map(element => {
        const text = (element.textContent || "").trim();
        const url = element.dataset.urlPattern || null;
        const value = element.dataset.value || null;

        return {
          element,
          text,
          url: url ? url.toLowerCase() : null,
          value
        };
      });
  }

  private get selectedElement(): HTMLAnchorElement | null {
    const selector = "[data-contains='specialties'] .active";

    return this._element.querySelector<HTMLAnchorElement>(selector);
  }

  private get specialtyElements(): ReadonlyArray<HTMLAnchorElement> {
    const selector = "[data-contains='specialties'] > a";
    const items = this._element.querySelectorAll<HTMLAnchorElement>(selector);

    return Array.from(items);
  }

  private handleSpecialtyClick(ev: Event): void {
    this.specialtyElements.forEach(item =>
      item.classList[item === ev.target ? "add" : "remove"]("active"));

    const selected = this.selectedElement;

    $("[data-toggle='dropdown']", this._element)
      .dropdown("toggle")
      .text(selected ? selected.textContent || "" : "");

    if (window.location.href === selected?.href) {
      ev.preventDefault();
      ev.stopPropagation();

      return;
    }

    if (selected) {
      console.log("Navigating Specialty Selected: " + selected.href);
      window.location.href = selected.href;
    }
  }

  private attemptUrlPatternMatch(): boolean {
    const ignorePaths = ["myhealiocme", "news", "search", "new-search", "cme"];
    const gtfoohPaths = ["footer","subscribe","cart","subscription-management","unsubscribe","my-account"];
    const match = window.location.pathname.split("/");
    const rootPath = this._element.dataset.rootPath||"";

    console.log({ds:this._element.dataset});

    if(rootPath.length > 0) {
      console.log("adding " + rootPath + " to the ignorePaths list");
      ignorePaths.push(rootPath);
    }

    let value: string = "";

    match.forEach(s => {
      if(!value && s && ignorePaths.indexOf(s.toLowerCase()) === -1){
        console.log("found " + value.toLowerCase() + " for specialty");
        value = s;
        return;
      }
    })
    
    const lc = value?.toLowerCase()??"";

    if (lc && (
      lc === "cme" ||
      lc === "topics" ||
      lc=== "authors" ||
      lc === "podcasts" ||
      lc === "meeting-news"
      )) {
      this._element.dispatchEvent(
        EventUtil.createCustomEvent(LandingCardLoader.LoadPageEvent, 1));

      return true;
    }



    if (!lc || gtfoohPaths.indexOf(lc) !== -1) {
      console.warn(
        "No  specialty in URL");

      return false;
    }

    const items = this.specialties;
    const item = items.find(s => s.url?.endsWith(lc));

    if (!item && isNaN(Number(lc))) {
      const newLocation = window.location.origin + window.location.pathname.replace(value, "").replace("//", "");
      // this is adding an additional slash before the path. window.location.pathname includes the preceeding slash already.
      // const newLocation = window.location.origin + "/" + window.location.pathname.replace(value, "").replace("//", "");
      console.warn(
        `Redirecting to ${newLocation}` +
        `URL value not found in specialty list: ${value}`,
        value);

      window.location.href = newLocation;

      return false;
    }

    this.setSelectedItem(item);

    return true;
  }

  private async attemptUserProfileMatch(): Promise<void> {
    const profile = await WyanokeUtil.loadUserProfile(true, false);

    if (profile) {
      const hasSpecialty =
        profile.isLoggedIn === "True" &&
        profile.contentspecialty;
      const queryStringMap = UrlUtil.getQueryString();

      if (hasSpecialty && queryStringMap.get("userspecialty") === undefined) {
        const specialty = (profile.contentspecialty || "").toLowerCase();
        //first check custom mappings
        if(this._element.dataset["customMappings"]){
          let maps : { [key: string]: string } = {};
          this._element.dataset["customMappings"].split(',').forEach(s => {
            let parts = s.split(':') as string[];
            maps[parts[0]] = parts[1];
          });

          if(maps[specialty]){
            console.log("Redirecting to Users Specialty Page: " + maps[specialty]);
            window.location.href = maps[specialty];
            return;
          }
        }

        //then check default mappings
        const items = this.specialties;
        const item = items.find(s => s.text.toLowerCase() === specialty);
        if (item && item.element) {
          console.log("Redirecting to Users Specialty Page: " + item.element.href);
          window.location.href = item.element.href;
          return;
        }
      }
    }
  }

  private setSelectedItem(item: ISpecialtyListItem | undefined): void {
    if(item === undefined) {

      return;
    }

    const items = this.specialties;
    items.forEach(i => {
      const action = i.element === item.element ? "add" : "remove";
      i.element.classList[action]("active");
    });

    const toggle = this._element.querySelector("[data-toggle='dropdown']");
    if (toggle) {
      toggle.textContent = item.text;
    }
  }

  private getCurrentDropDownValue(): string | null {
    const toggle = this._element.querySelector("[data-toggle='dropdown']");

    return toggle ? toggle.textContent : "";
  }
}

ComponentFactory.registerComponent("SpecialtySelect", SpecialtySelect);
